module.exports = __webpack_public_path__ + "media/images/grey_logos/w-post-3ee717596f98b0d4bd5f65a78d9fb833.svg";